<div *ngIf="show" class="overlay">
    <mat-spinner
        [diameter]="diameter"
        [mode]="mode"
        [color]="color"
        [strokeWidth]="strokeWidth">
    </mat-spinner>
</div>
